import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import leadTimeService from "services/leadTimeService";
import { formConvertErrorMessage } from "../../helpers/form_helper";

// Create
export const useCreateLeadTime = (onSuccess, onError) => {
  return useMutation(leadTimeService.createLeadTime, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateLeadTime = (onSuccess, onError) => {
  return useMutation(leadTimeService.updateLeadTime, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDeleteLeadTime = (onSuccess, onError) => {
  return useMutation(leadTimeService.deleteLeadTime, {
    retry: 0,
    onSuccess: data => {
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useListLeadTime = (payload, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation();

  return useQuery(
    ["locations", payload?.params],
    () => leadTimeService.geListLeadTime(payload),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.fetch_profile", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      // initialData: [],
      select: response => {
        const { data } = response;

        return {
          items: data?.items || [],
        };
      },
    }
  );
};
